import React, {useState} from 'react';
import { EnterAchDetailsSection } from './EnterAchDetailsSection';
import { EnterCreditCardDetailsSection } from './EnterCreditCardDetailsSection';
import { Constants } from '../../Constants';

// Contains what the paying party is paying for. 
// NOTE: This isn't doing the proper "lifting state up" thing, primarily because
// its not as necessary here for now, we needn't pass in values via props
// Rather, the user add inputs here, and the parent only needs to know these values 
// to populate the confirmation page
const ChoosePaymentMethodSection = (props) => {    
    const [paymentDetails, updatePaymentDetails]
        = useState({paymentAmount:"", 
                    paymentType:"creditCardPayment",
                    billingAddress: "",
                    creditCardDetails: "",
                    achDetails: "",                    
                    });

    const updatePaymentAmount = (amount) => {
        var details = {...paymentDetails};
        details.paymentAmount = amount;
        updatePaymentDetails(details);
        props.onChange(details);
    }
    const updatePaymentMethod = (type) => {
        var details = {...paymentDetails};
        details.paymentType = type;
        updatePaymentDetails(details);
        props.onChange(details);
    }
    const updateBillingAddress = (updatedAddressInfo) => {
        props.onChange(updatedAddressInfo);
    }
    const updateCreditCardDetails = (updatedCreditCardDetails) => {
        props.onChange(updatedCreditCardDetails);
    }
    const updateAchDetails = (updatedAchDetails) => {
        props.onChange(updatedAchDetails);
    }
    const [paymentCard, updatePaymentCard] = useState(<EnterCreditCardDetailsSection onAddressUpdate={updateBillingAddress} onCreditCardDetailsUpdate={updateCreditCardDetails}/>);

    return (
        <div className="row mt-2">            
            <div className="col-12 mt-2">                
                <div className="row">
                    <div className="col-auto mx-auto h5">
                        <strong>Payment amount</strong>
                    </div>
                </div>
            </div>
            <div className="col-auto mx-auto mb-2">
                <label className="control-label">Payment amount:</label>
                <div className="input-group mb-3">
                    <div className="input-group-prepend">
                        <span className="input-group-text text-white bg-success" id="payment-amount">$</span>
                    </div>
                    <input required type="number" step=".01" min={0} aria-describedby="payment-amount" 
                        name="paymentAmount" className="form-control" onChange={(e) => updatePaymentAmount(e.target.value)}/>
                </div>
            </div>
            <div className="col-12 mb-2">
                {/* <strong>Please select your payment method</strong><br /> */}
				{/* 06/16/2021: Credit card fee removed */}
				{/* 11/03/2021: Credit card fee re-added */}
				Please note that there is a {Constants.creditCardFeePercentText} transaction fee for credit card.
                <em className="text-muted">Only U.S. credit cards are accepted. </em>
                {/* <div className="form-check my-1">
                    <input required type="radio" className="form-check-input"
                        id="ACH-Payment-Type" disabled={true} name="paymentType" value="achPayment"
                        onClick={() => {
                            updatePaymentCard(<EnterAchDetailsSection onAddressUpdate={updateBillingAddress} />);
                            updatePaymentMethod("achPayment");
                        }}/>

                    <label className="form-check-label" htmlFor="ACH-Payment-Type">
                        ACH payment (currently unavailable)
                    </label>
                </div> */}

                <div className="form-check mb-1">
                    <input required type="radio" className="form-check-input"
                        id="Credit-Card-Payment" name="paymentType" value="creditCardPayment"
						checked={paymentDetails.paymentType === "creditCardPayment"}
                        onClick={() => {
                            updatePaymentCard(<EnterCreditCardDetailsSection onAddressUpdate={updateBillingAddress} onCreditCardDetailsUpdate={updateCreditCardDetails}/>);
                            updatePaymentMethod("creditCardPayment");
                        }}/>
                        
                    <label className="form-check-label" htmlFor="Credit-Card-Payment">
                        Credit Card
                    </label>
                </div>
            </div>
            <div className="col-12">
                {paymentCard}
            </div>
        </div>
    );
}

export { ChoosePaymentMethodSection }